import { AI_QUALITY_EVENTS } from './quality-events-pages/ai-quality-events';
import { AUTHENTICATION_EVENTS } from './quality-events-pages/authentication-quality-events';
import { AUTHOR_QUALITY_EVENTS } from './quality-events-pages/author-page-quality-events';
import { CART_PAGE_EVENTS } from './quality-events-pages/cart-page-quality-events';
import { CHECKOUT_PAGE_EVENTS } from './quality-events-pages/checkout-page-quality-events';
import { FAVORITES_PAGE_QUALITY_EVENTS } from './quality-events-pages/favorites-page-quality-events';
import { GENERAL_QUALITY_EVENTS } from './quality-events-pages/general-quality-events';
import { HEADER_EVENTS } from './quality-events-pages/header-quality-events';
import { HOME_PAGE_QUALITY_EVENTS } from './quality-events-pages/home-page-quality-events';
import { MATERIAL_FEEDBACK_QUALITY_EVENTS } from './quality-events-pages/material-feedback-page-quality-events';
import { MATERIAL_PAGE_EVENTS } from './quality-events-pages/material-page-quality-events';
import { MY_MATERIALS_PAGE_EVENTS } from './quality-events-pages/my-materials-page-quality-events';
import { MY_UPLOADS_QUALITY_EVENTS } from './quality-events-pages/my-uploads-quality-events';
import { SCHOOL_ACCOUNT_QUALITY_EVENTS } from './quality-events-pages/school-account-quality-events';
import { SRCH_QUALITY_EVENTS } from './quality-events-pages/search-quality-events';
import { THANK_YOU_PAGE_QUALITY_EVENTS } from './quality-events-pages/thank-you-page-quality-events';

const qualityEvents = {
    ai: { ...AI_QUALITY_EVENTS },
    authentication: { ...AUTHENTICATION_EVENTS },
    author: { ...AUTHOR_QUALITY_EVENTS },
    cartPage: { ...CART_PAGE_EVENTS },
    checkoutPage: { ...CHECKOUT_PAGE_EVENTS },
    favoritesPage: { ...FAVORITES_PAGE_QUALITY_EVENTS },
    general: { ...GENERAL_QUALITY_EVENTS },
    header: { ...HEADER_EVENTS },
    homePage: { ...HOME_PAGE_QUALITY_EVENTS },
    materialPage: { ...MATERIAL_PAGE_EVENTS },
    materialFeedbackPage: { ...MATERIAL_FEEDBACK_QUALITY_EVENTS },
    myUploads: { ...MY_UPLOADS_QUALITY_EVENTS },
    myMaterialsPage: { ...MY_MATERIALS_PAGE_EVENTS },
    search: { ...SRCH_QUALITY_EVENTS },
    schoolAccount: { ...SCHOOL_ACCOUNT_QUALITY_EVENTS },
    thankYouPage: { ...THANK_YOU_PAGE_QUALITY_EVENTS }
};

export default qualityEvents;
